<template>
    <router-view></router-view>
</template>

<script>
export default {
  name: 'Auth'
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/user/Auth.vue